






















































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";

export interface ItemWpPopup {
  titulo: string;
  qty: number;
  precio_amazon: number;
  precio_venta: number;
  imagen?: string;
}

@Component
export default class PublicarWpPopup extends Vue {
  @Prop({ required: true }) mostrar!: boolean;
  @Prop({ required: true }) items!: ItemWpPopup[];
  @Prop({ default: "" }) nombreInicial!: string;
  /** Si es true, publica usando publicarCarritoWordpress en vez de crear producto individual */
  @Prop({ default: false }) modoCarrito!: boolean;
  @Prop({ default: 0 }) cartId!: number;

  // --- Estado interno ---
  nombre = "";
  descripcion = "";
  precio = 0;
  categorias: any[] = [];
  categoriaSeleccionada: number | null = null;
  categoriaSugerida = "";
  justificacion = "";

  cargandoIA = false;
  iaOk = false;
  errorIA = "";
  errorCategorias = "";
  loadingCategorias = false;
  publicando = false;
  resultado: any = null;

  @Watch("mostrar")
  async onMostrarChange(val: boolean) {
    if (val) {
      // Reiniciar estado
      this.resultado = null;
      this.errorIA = "";
      this.errorCategorias = "";
      this.iaOk = false;
      this.nombre = this.nombreInicial || "";
      this.descripcion = "";
      this.categoriaSugerida = "";
      this.justificacion = "";
      this.precio = this.calcularPrecioTotal();

      // Cargar categorías + lanzar IA en paralelo
      await Promise.all([
        this.cargarCategorias(),
        this.pedirSugerenciaIA(),
      ]);
    }
  }

  /** Calcula el precio total del lote sumando precio_venta * qty (con descuento ya aplicado) */
  calcularPrecioTotal(): number {
    return this.items.reduce((sum, it) => sum + (it.precio_venta || 0) * (it.qty || 1), 0);
  }

  /** Calcula el precio total Amazon del lote sumando precio_amazon * qty */
  calcularPrecioAmazonTotal(): number {
    return this.items.reduce((sum, it) => sum + (it.precio_amazon || 0) * (it.qty || 1), 0);
  }

  async cargarCategorias() {
    if (this.categorias.length > 0) return;
    this.loadingCategorias = true;
    this.errorCategorias = "";
    try {
      const res = await ssmHttpService.get(API.wordpressSuite + "categorias");
      this.categorias = this.normalizeCategorias(res);
      if (this.categorias.length === 0) {
        this.errorCategorias = "No hay categorías de WordPress disponibles.";
      }
    } catch (e) {
      this.errorCategorias = "No se pudieron cargar las categorías de WordPress.";
      console.warn("No se pudieron cargar categorías WP:", e);
    } finally {
      this.loadingCategorias = false;
    }
  }

  async pedirSugerenciaIA() {
    if (!this.items || this.items.length === 0) return;

    this.cargandoIA = true;
    this.iaOk = false;
    this.errorIA = "";

    // Construir listado de artículos para el prompt
    const lineasTexto = this.items
      .map((it) => `- ${it.titulo} x${it.qty} — ${it.precio_venta.toFixed(2)} €`)
      .join("\n");

    const prompt =
      `Eres un experto en e-commerce para WooCommerce. Tengo este lote de productos outlet para vender:\n` +
      lineasTexto +
      `\n\nResponde ÚNICAMENTE con un JSON válido (sin markdown, sin explicaciones extra) con esta estructura exacta:\n` +
      `{"nombre":"...","descripcion":"...","categoria_sugerida":"...","justificacion":"..."}\n` +
      `El nombre debe ser atractivo y conciso (máx 60 chars). La descripción: 2-3 frases persuasivas en español, ` +
      `destacando el ahorro respecto al precio de Amazon. La categoría sugerida debe ser una sola palabra o término ` +
      `del sector (electrónica, hogar, deporte, juguetes, etc.).`;

    try {
      const res = await ssmHttpService.post(
        API.chatIA + "chat",
        { ConversacionId: null, Mensaje: prompt },
        false
      );

      const raw = this.getIaRawResponse(res);

      // Extraer el JSON (a veces viene envuelto en ```json ... ```)
      const jsonMatch = raw.match(/\{[\s\S]*\}/);
      if (jsonMatch) {
        let parsed: any;
        try {
          parsed = JSON.parse(jsonMatch[0]);
        } catch (parseError) {
          this.errorIA = "La IA no devolvió un formato válido. Puedes rellenar los campos manualmente.";
          return;
        }

        const nombre = this.getIaField(parsed, "nombre");
        const descripcion = this.getIaField(parsed, "descripcion");
        const categoriaSugerida = this.getIaField(parsed, "categoria_sugerida");
        const justificacion = this.getIaField(parsed, "justificacion");

        if (!nombre && !descripcion && !categoriaSugerida && !justificacion) {
          this.errorIA = "La IA no devolvió un formato válido. Puedes rellenar los campos manualmente.";
          return;
        }

        this.nombre = nombre || this.nombre;
        this.descripcion = descripcion || "";
        this.categoriaSugerida = categoriaSugerida || "";
        this.justificacion = justificacion || "";

        // Intentar preseleccionar la categoría si coincide con alguna
        if (this.categoriaSugerida && this.categorias.length > 0) {
          const match = this.categorias.find(
            (c: any) => c.name.toLowerCase().includes(this.categoriaSugerida.toLowerCase())
              || this.categoriaSugerida.toLowerCase().includes(c.name.toLowerCase())
          );
          if (match) this.categoriaSeleccionada = match.id;
        }

        this.iaOk = true;
      } else {
        this.errorIA = "La IA no devolvió un formato válido. Puedes rellenar los campos manualmente.";
      }
    } catch (e) {
      this.errorIA = "No se pudo contactar con la IA. Rellena los campos manualmente.";
      console.warn("Error IA:", e);
    } finally {
      this.cargandoIA = false;
    }
  }

  private getIaRawResponse(res: any): string {
    if (typeof res === "string") return res;
    if (!res) return "";
    return res.respuesta || res.Respuesta || "";
  }

  private getIaField(data: any, fieldName: string): string {
    if (!data || typeof data !== "object") return "";

    const expected = this.normalizeIaKey(fieldName);
    const entry = Object.keys(data).find((key) => this.normalizeIaKey(key) === expected);
    const value = entry ? data[entry] : "";

    return value === undefined || value === null ? "" : String(value).trim();
  }

  private normalizeIaKey(key: string): string {
    return String(key)
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[_\s-]/g, "");
  }

  private normalizeCategorias(res: any): any[] {
    const items = Array.isArray(res)
      ? res
      : (res && Array.isArray(res.items))
        ? res.items
        : (res && Array.isArray(res.data))
          ? res.data
          : (res && Array.isArray(res.categories))
            ? res.categories
            : [];

    return items
      .map((cat: any) => ({
        id: Number(cat.id || cat.ID || cat.term_id || cat.termId),
        name: String(cat.name || cat.nombre || cat.Name || "").trim(),
      }))
      .filter((cat: any) => cat.id > 0 && cat.name);
  }

  async publicar() {
    if (!this.categoriaSeleccionada) return;

    this.publicando = true;
    this.resultado = null;

    try {
      let res: any;

      if (this.modoCarrito && this.cartId) {
        // Publicar usando el endpoint de lote (carritos)
        res = await ssmHttpService.post(
          API.publicarCarritoWordpress + this.cartId,
          {
            categoria_id: this.categoriaSeleccionada,
            nombre_personalizado: this.nombre,
            descripcion: this.descripcion,
          }
        );
      } else {
        // Publicar como producto individual (presupuestos/facturas)
        res = await ssmHttpService.post(API.wordpressSuite + "productos", {
          name: this.nombre,
          description: this.descripcion,
          regular_price: String(this.precio.toFixed(2)),
          categories: [{ id: this.categoriaSeleccionada }],
          status: "publish",
          image_urls: this.getImageUrlsParaWp(),
          public_base_url: this.getBackendPublicBaseUrl(),
          // Precio Amazon total para calcular el % descuento en el collage
          precio_amazon_total: this.calcularPrecioAmazonTotal(),
        });
      }

      this.resultado = {
        ok: true,
        wp_product_id: (res && res.wp_product_id) || (res && res.id) || null,
        url: (res && res.url) || (res && res.permalink) || "",
      };
      this.$emit("publicado", this.resultado);
    } catch (e) {
      const msg =
        (e && e.response && e.response.data && e.response.data.error) ||
        (e && e.message) ||
        "Error desconocido al publicar en WordPress";
      this.resultado = { ok: false, error: msg };
    } finally {
      this.publicando = false;
    }
  }

  private getImageUrlsParaWp(): string[] {
    const urls = (this.items || [])
      .map((item) => item.imagen || "")
      .filter((url, index, all) => url && all.indexOf(url) === index);

    return urls.slice(0, 4);
  }

  private getBackendPublicBaseUrl(): string {
    const apiBase = String(API.webApiBase || "");
    if (apiBase) {
      return apiBase.replace(/\/api\/?$/i, "");
    }

    return window.location.origin;
  }
}
